import { HealthDocument } from '@/features/ocr/types/HealtDocument';
import { BASE_URL } from '@/utils/Constants';
import { useAuth } from '@/utils/stores/useAuthStore';
import { useQuery } from '@tanstack/react-query';

export const getDocuments = async (userId: string, token: string) => {
  const response = await fetch(`${BASE_URL}/api/documents/user/${userId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error('Failed to fetch documents');
  }
  
  return data.map((el: any) => ({
    ...el,
    createdAt: new Date(el.document_date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }),
    labName: el.lab_name,
    numberOfParameters: el.markers_count,
  })) as HealthDocument[];
};

export const useGetDocuments = () => {
  const { userId, idToken } = useAuth();
  const { data, isLoading, error } = useQuery({
    queryKey: ['documents', userId, idToken],
    queryFn: () => getDocuments(userId!, idToken!),
    enabled: !!userId && !!idToken,
  });
  return { data, isLoading, error };
};
